module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<form id="' +
((__t = (id)) == null ? '' : __t) +
'" name="gazetteer">\n    ';
 _.each(levels,function(level,index) { ;
__p += '\n    <div class="form-group row">\n        <select class="DescartesUISelect form-control" id="' +
((__t = (id)) == null ? '' : __t) +
'_' +
((__t = (index)) == null ? '' : __t) +
'">\n            ';
 if(!_.isEmpty(levels)) {
                var level = levels[index];
                var selected = selections[index];
                if(!_.isEmpty(level.datasList)) {

                    if(!_.isNil(level.message)) {
                        print('<option value="0" selected>'+level.message+'</option>');
                    } else {
                        print('<option value="0" selected>'+level.error+'</option>')
                    }
                     var dataList = level.datasList;
                     _.each(dataList,function(data) {
            ;
__p += '\n            <option value="' +
((__t = (data.code)) == null ? '' : __t) +
'"\n                    ';

                        if(selected === data.code) {
                            print('selected');
                        }
                    ;
__p += '\n                    >' +
((__t = (data.nom)) == null ? '' : __t) +
'</option>\n            ';
});
            } else if(level.hasError===true && level.error) {
                print('<option>'+level.error+'</option>')
            }};
__p += '\n        </select>\n    </div>\n    ';
 });;
__p += '\n    <button type="submit" class="DescartesUIButtonSubmit btn ' +
((__t = (btnCssSubmit)) == null ? '' : __t) +
'">' +
((__t = (buttonMessage)) == null ? '' : __t) +
'</button>\n</form>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/UI/bootstrap4/templates/GazetteerInPlace.ejs
// module id = 168
// module chunks = 0